import React from 'react'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'

import { selectMediaCache, loadMedia } from '@SonarCX/slices/mediaCache'

const useMediaCache = () => {
  const dispatch = useAppDispatch()

  const { status, media } = useAppSelector(selectMediaCache)

  const getMedia = React.useCallback(
    (url: string, resize?: boolean) => {
      dispatch(loadMedia(url, resize))
    },
    [dispatch]
  )

  return {
    status,
    media,
    getMedia
  }
}

export default useMediaCache
